import { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import SearchBar from '../../Components/SearchBar/SearchBar';
import styles from './ListPage.module.scss';
import { Button } from '@/Components/ui/button';

const CREATE_EXCLUSIONS = [
	'STORE_SETTINGS',
	'PRINTER_CONFIG',
	'VARIANTS',
	'SUBSCRIPTION',
	'NUTRITION',
	'COOKING_PRODUCT_CONFIG',
	'APPROVE_REFUNDS',
	'REFUND_HISTORY',
	// 'REQUEST_REFUND',
	'PAYMENT_SETTLEMENTS',
	'CUSTOMIZATIONS',
	'MY_CUSTOMERS',
	'INVENTORY CONFIG',
	'QUALITY CONFIG',
	'SKU STOCK REPORT',
];

const HEADER_EXCLUSIONS = ['QUALITY_SETTING', 'VENDORS'];

const ListPage = (props) => {
	const {
		entity,
		ListComponent,
		placeholder,
		listPageProps,
		listFilter,
		searchBy,
		userPermissions,
		searchOnClick = false,
		header = false,
		listHeader = '',
		headerName = '',
		type,
	} = props;
	const { url } = useRouteMatch();
	const history = useHistory();
	const [state, setState] = useState(() => {
		return {
			query: '',
			searchField: searchBy?.options?.[0] != null ? 0 : null,
		};
	});

	const [dummyQuery, setDummyQuery] = useState('');

	const navigateToAddItem = () => {
		history.push(`${url}/new`);
	};

	const handleInput = (query) => {
		if (searchOnClick) {
			setDummyQuery(query);
		} else {
			setState({
				...state,
				query,
			});
		}
	};

	const handleChange = (searchField) => {
		setState({
			...state,
			searchField,
		});
	};

	const handleClickSearch = () => {
		setState({
			...state,
			query: dummyQuery,
		});
	};

	return (
		<div className={`${styles['list-view-root']} page`}>
			{listHeader && (
				<div className='w-full pt-3 px-4'>
					<p className='text-lg font-semibold'>{listHeader}</p>
				</div>
			)}
			{HEADER_EXCLUSIONS.indexOf(entity) === -1 && (
				<div className={`${styles['list-view-header']}`}>
					{ searchOnClick ? (
						<div style={{
							display: 'flex',
							width: '100%',
							justifyContent: 'space-around',
						}}
						>
							<SearchBar
								handleInput={handleInput}
								handleChange={handleChange}
								searchBy={
									searchBy != null
										? {
											...(searchBy ?? {}),
											current: state.searchField,
										}
										: null
								}
								placeholder={placeholder}
							/>
							<Button
								className='ml-2.5 primary-btn'
								onClick={handleClickSearch}
							>
								Find
							</Button>
						</div>
					) : (
						<div className='search-bar'>
							{header === true ? <p className='text-xl font-medium'>{headerName}</p> : (
								<SearchBar
									handleInput={handleInput}
									handleChange={handleChange}
									searchBy={
										searchBy != null
											? {
												...(searchBy ?? {}),
												current: state.searchField,
											}
											: null
									}
									placeholder={placeholder}
								/>
							)}
						</div>
					)}

					{listFilter && (
						<div className={styles.filter}>{listFilter}</div>
					)}
					{userPermissions?.CREATE &&
						CREATE_EXCLUSIONS.indexOf(entity) === -1 && (
						<Button
							// variant='contained'
							// color='primary'
							className='bg-uy-color text-black'
							onClick={navigateToAddItem}
						>
							{entity === 'Quote' ? 'Raise RFQ' : `+ ADD ${entity}`}
						</Button>
					)}
				</div>
			)}
			<ListComponent
				query={state.query}
				listPageProps={listPageProps}
				searchBy={searchBy?.options?.[state?.searchField]}
				type={type}
			/>
		</div>
	);
};
ListPage.defaultProps = {
	placeholder: 'Search By Name',
};
export default ListPage;
